<template>
  <v-card v-if="is_loaded" ref="form" elevation="0" class="pa-0">
    <v-card-text v-if="toggle_exclusive === 0" class="pa-0">
      <div class="tbl-col tbl-f">
        <div class="c-row span2C">
          <div class="c-td w2"></div>
          <div v-for="(level, idx) in level_headers" :key="idx" class="c-col w2">
            <div class="c-th th-f">{{ level.name }}</div>

            <div v-if="level.level !== 0" class="c-th th-f price">${{ level.add_column.price }}</div>
            <div v-else class="c-th th-f price">免費試用7天</div>
          </div>
        </div>
        <template v-for="(category, idx) in categories">
          <div :key="`c_${idx}`" class="c-row">
            <div class="c-thead wadj">
              <h1 class="c-h1">{{ category.name }}</h1>
            </div>
          </div>

          <div v-if="category.category.length > 0" :key="`d_${idx}`">
            <template v-for="(sub_category, f_idx) in category.category">
              <div :key="`f_${f_idx}`" class="c-row category">
                <div
                  class="c-td category-name w2"
                  :category="`${sub_category.name}`"
                  @click="activateDetails(sub_category.name)"
                >
                  <span class="c-arrow"> ▼ </span>
                  {{ sub_category.name }}
                </div>

                <template v-for="(level_quota, level_quota_idx) in sub_category.features[0].levelRemainingRes">
                  <div
                    v-if="
                      (sub_category.features[0].function.includes('Release') ||
                        sub_category.features[0].function.includes('Activate')) &&
                      level_quota.level !== -1
                    "
                    :key="level_quota_idx"
                    class="c-col w2"
                    style="display: none"
                  >
                    <div class="c-th c-td-title">{{ level_quota.remaining }}</div>
                  </div>
                </template>
              </div>

              <div
                v-for="(feature, feature_idx) in sub_category.features"
                :key="`f4_${feature.function}_${feature_idx}`"
                :category="`${sub_category.name}`"
                class="c-row"
              >
                <div class="c-td feature-name w2" style="cursor: pointer" @click="editFeatureName(feature)">
                  <span>{{ feature.name }}</span>

                  <v-tooltip v-if="feature.memo" right color="white">
                    <template #activator="{ on, attrs }">
                      <v-btn class="ml-2" icon x-small v-bind="attrs" v-on="on">
                        <v-icon color="white"> mdi-information-variant-circle </v-icon>
                      </v-btn>
                    </template>
                    <span class="black--text">{{ feature.memo }}</span>
                  </v-tooltip>
                </div>

                <template v-for="(level_quota, level_quota_idx) in feature.levelRemainingRes">
                  <div v-if="level_quota.level !== -1" :key="level_quota_idx" class="c-col w2">
                    <div v-if="feature.type !== 'boolean'">{{ level_quota.remaining }}</div>
                    <div v-else>
                      <span v-if="level_quota.remaining === 1">✅</span>
                      <span v-else>❌</span>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>

          <div v-if="category.features && category.features.length > 0" :key="`d_${idx}`" class="c-row">
            <template v-for="(feature, f_idx) in category.features">
              <div :key="`${feature.function}_${f_idx}`" class="c-td feature-name w2">
                {{ feature.name }}
              </div>

              <template v-for="(level_quota, level_quota_idx) in feature.levelRemainingRes">
                <div v-if="level_quota.level !== -1" :key="level_quota_idx" class="c-col w2">
                  <div class="">{{ level_quota.remaining }}</div>
                </div>
              </template>
            </template>
          </div>
        </template>
      </div>
    </v-card-text>

    <v-card-text v-else class="pa-0">
      <template v-for="(level, idx) in level_headers">
        <div
          :key="idx"
          class="tbl-col tbl-f"
          :class="{
            'mt-3': idx !== 0,
          }"
        >
          <div class="c-row mobile span2C">
            <div class="c-col mobile w12">
              <div class="c-th th-f">{{ level.name }}</div>

              <div v-if="level.level !== 0" class="c-th th-f price">${{ level.add_column.price }}</div>
              <div v-else class="c-th th-f price">免費試用7天</div>
            </div>
          </div>
        </div>
        <template v-for="(category, idx) in categories">
          <div :key="`c_${level.level}_${idx}`" class="c-row mobile">
            <div class="c-thead wadj">
              <h1 class="c-h1">{{ category.name }}</h1>
            </div>
          </div>

          <div v-if="category.category.length > 0" :key="`d_${level.level}_${idx}`">
            <template v-for="(sub_category, f_idx) in category.category">
              <div :key="`f_${f_idx}`" class="c-row mobile category">
                <div
                  class="c-td category-name w5"
                  :category="`${sub_category.name}`"
                  :level="`${level.level}`"
                  @click="activateDetails(sub_category.name, level.level)"
                >
                  <span class="c-arrow"> ▼ </span>
                  {{ sub_category.name }}
                </div>

                <div class="c-col mobile" style="display: none">
                  <div class="c-th c-td-title">{{ gogo(sub_category.features[0], level).remaining }}</div>
                </div>
              </div>

              <div
                v-for="(feature, feature_idx) in sub_category.features"
                :key="`f4_${feature.function}_${feature_idx}`"
                :category="`${sub_category.name}`"
                :level="`${level.level}`"
                class="c-row mobile"
              >
                <div class="c-td feature-name w5">
                  <span>{{ feature.name }}</span>

                  <v-tooltip v-if="feature.memo" right color="white">
                    <template #activator="{ on, attrs }">
                      <v-btn class="ml-2" icon x-small v-bind="attrs" v-on="on">
                        <v-icon color="white"> mdi-information-variant-circle </v-icon>
                      </v-btn>
                    </template>
                    <span class="black--text">{{ feature.memo }}</span>
                  </v-tooltip>
                </div>

                <div class="c-col mobile w2">
                  <div v-if="feature.type !== 'boolean'">{{ gogo(feature, level).remaining }}</div>
                  <div v-else>
                    <span v-if="gogo(feature, level).remaining === 1">✅</span>
                    <span v-else>❌</span>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div
            v-if="category.features && category.features.length > 0"
            :key="`d_${level.level}_${idx}`"
            class="c-row mobile"
          >
            <template v-for="(feature, f_idx) in category.features">
              <div :key="`${feature.function}_${f_idx}`" class="c-td feature-name w5">
                {{ feature.name }}
              </div>

              <div :key="`p_${feature.function}_${f_idx}`" class="c-col mobile">
                <div class="">{{ gogo(feature, level).remaining }}</div>
              </div>
            </template>
          </div>
        </template>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import { apiGetSubscriptionTree } from '@/api/subcription.js'

export default {
  name: 'LevelUsage',
  components: {},
  data() {
    return {
      level_headers: [],
      categories: [],
      is_loaded: false,
      toggle_exclusive: 0,
    }
  },
  computed: {},
  created: async function () {},
  async mounted() {
    try {
      await this.getData()
    } catch (error) {
      console.log('error:', error)
      this.$root.vtoast.show({
        message: `取得階級模組失敗: ${error}`,
      })
    }

    console.log('sub_width:', window.innerWidth)
    if (window.innerWidth <= 768) {
      this.toggle_exclusive = 1
    }

    let that = this
    setTimeout(function () {
      let card = that.$refs.form
      let height = getComputedStyle(card.$el).height
      let data = {
        height: height,
      }
      console.log('sub_height:', height)
      parent.postMessage(data, '*')
    }, 1000)

    // let titles = Array.from(document.querySelectorAll('.c-th.c-td-title'))
    // titles.forEach((title) => {
    //   title.parentElement.style.display = 'none'
    // })
  },
  methods: {
    async getData() {
      try {
        let result = await apiGetSubscriptionTree()
        console.log('result:', result)
        this.level_headers = result.level_headers.filter(function (level_header) {
          return level_header.level !== 99 && level_header.level !== -1
        })
        this.categories = result.categories

        this.categories.forEach(function (category) {
          console.log(category.category)
          if (category.features) {
            category.features.forEach(function (feature) {
              feature.levelRemainingRes = feature.levelRemainingRes.sort((a, b) => a.level - b.level)

              feature.levelRemainingRes = feature.levelRemainingRes.filter(function (level_remaining) {
                return level_remaining.level !== 99
              })
            })
          }

          category.category.forEach(function (sub_category) {
            sub_category.features.forEach(function (feature) {
              feature.levelRemainingRes = feature.levelRemainingRes.sort((a, b) => a.level - b.level)
              feature.levelRemainingRes = feature.levelRemainingRes.filter(function (level_remaining) {
                return level_remaining.level !== 99
              })
            })
          })
        })

        this.is_loaded = true
      } catch (error) {
        this.$root.vtoast.show({
          message: `取得階級模組失敗: ${error}`,
        })
      }
    },
    activateDetails(category_name, level) {
      console.log('category_name', category_name)
      console.log('level', level)
      let category_features = Array.from(document.querySelectorAll(`.c-row[category="${category_name}"]`))
      let category_arrow = document.querySelector(`.category-name[category="${category_name}"] > .c-arrow`)
      console.log('category_features', category_features)
      let total_row = document.querySelector(`.category-name[category="${category_name}"]`).parentElement
      let numbers = Array.from(total_row.querySelectorAll(`:scope > div:not(.category-name)`))
      console.log('numbers', numbers)
      if (!isNaN(parseInt(level))) {
        category_features = Array.from(
          document.querySelectorAll(`.c-row[category="${category_name}"][level="${level}"]`)
        )
        category_arrow = document.querySelector(
          `.category-name[category="${category_name}"][level="${level}"] > .c-arrow`
        )
      }

      let is_deactivate = category_arrow.className.includes('deactivate-detail')
      if (is_deactivate) {
        category_arrow.classList.remove('deactivate-detail')
        category_arrow.innerText = '▼'
        category_features.forEach(function (category_feature) {
          category_feature.classList.remove('deactivate-detail')
        })
        numbers.forEach((number) => {
          number.style.display = 'none'
        })
      } else {
        category_arrow.classList.add('deactivate-detail')
        category_arrow.innerText = '►'
        category_features.forEach(function (category_feature) {
          category_feature.classList.add('deactivate-detail')
        })
        numbers.forEach((number) => {
          number.style.display = 'flex'
        })
      }

      let that = this
      setTimeout(function () {
        let card = that.$refs.form
        let height = getComputedStyle(card.$el).height
        let data = {
          height: height,
        }
        parent.postMessage(data, '*')
      }, 300)
    },
    gogo(feature, level) {
      let level_quota = feature.levelRemainingRes.find(function (levelRemaining) {
        return levelRemaining.level === level.level
      })
      return level_quota
    },
  },
}
</script>
<style scoped>
.right-align >>> input {
  text-align: right !important;
}
.center-align {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style scoped>
.level-wrapper {
  background-color: #000;
}
.tbl-col {
  display: flex;
  flex-flow: column nowrap;
  overflow: auto;
  margin: auto;
}
.tbl-f {
  font-size: 95%;
  width: 100%;
}
.c-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.c-col.mobile {
  flex: 1;
}
.c-row {
  background-color: #343434;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.c-row.mobile {
  justify-content: left;
}
.c-row.category {
  border-bottom: 1px #ffffff solid;
}
/* .c-row:nth-child(2n) {  
    background-color:#2c2c2c;
}
.c-row:nth-child(2n+1) {  
    background-color:#343434;color: white;
} */
.c-th,
.c-td,
.c-thead {
  display: flex;
  align-items: center;
  border: 0;
  flex-shrink: 0;
}
.c-td {
  justify-content: center;
  height: 3.5em;
}
.c-td.category-name {
  justify-content: left;
  cursor: pointer;
  font-weight: bold;
}
.c-td.feature-name {
  justify-content: left;
  padding-left: 10px;
}
.w3 {
  width: 24%;
}
.w1 {
  width: 8.33%;
}
.w2 {
  width: 16.66%;
}
.w4 {
  width: 33.32%;
}
.w5 {
  width: 41.65%;
}
.w12 {
  width: 100%;
}
.th-f.price {
  font-size: 100%;
}
.c-input {
  color: #fff;
  text-align: center;
}
/** table header start */
.span2C {
  height: 6em;
  padding: 20px 0 0 0;
  background-image: linear-gradient(37deg, #bf8b2a, #eac677, #f2d785, #f2d06b, #bf8b2a);
}
.th-f {
  font-size: 140%;
  text-align: center;
  color: #000000;
  font-weight: bold;
}
.c-td-title {
  font-size: 110%;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
}
/** table feature category */
.c-thead {
  background-image: linear-gradient(90deg, #f2d06b, #f2d785, #f2d06b);
  justify-content: flex-start;
  height: 3em;
  color: #000000;
  border-top: 1px solid #bf8b2a;
}
.wadj {
  flex-grow: 1;
}
.c-h1 {
  font-size: 110%;
  margin: 0;
  padding: 0;
  padding-left: 10px;
}
/** 功能 */
.c-title {
  font-weight: bold;
}
.c-subtitle {
  justify-content: flex-start;
  border-right: 1px solid #000;
  font-weight: bold;
}
.c-arrow {
  padding: 0px 10px;
}
.c-row.deactivate-detail {
  display: none;
}
</style>
